import { AttachmentType, AttachmentTypeTranslations } from '@/enums/attachmentType.enum';
import { HistoryActionTranslations } from '@/enums/historyAction.enum';
import { TableName, TableNameTranslations } from '@/enums/tableName';
import { HistoryLog } from '@/interfaces/historyLog';
import store from '@/store/store';

/**
 * Tłumaczy zmiany historii
 *
 * @export
 * @param {HistoryLog} log
 * @returns {string}
 */
export function historyChanges(log: HistoryLog): string {
  if (!log.changes) {
    return '';
  }

  if (log.json === false) {
    return log.changes;
  }

  const changes = JSON.parse(log.changes);
  if (changes.after?.statusId && changes.before?.statusId) {
    const getter = store.getters['status/byId'];
    const before = getter(changes.before.statusId)?.name;
    const after = getter(changes.after.statusId)?.name;
    if (after && before) {
      return `Zmieniono z: ${before}, na: ${after}`;
    }
  }

  if (changes.before?.checksum && changes.after?.checksum) {
    return `Suma kontrolna zmieniona z: "<span class="checksum">${changes.before.checksum}</span>", na: "<span class="checksum">${changes.after.checksum}</span>"`;
  }

  if (log.tableName === TableName.attachment) {
    const name = changes.after?.name || changes.before?.name;
    const type: AttachmentType = changes.after?.type || changes.before?.type;
    return HistoryActionTranslations[log.action] + ' ' + AttachmentTypeTranslations[type] + ': \n' + name;
  }

  if (log.tableName === TableName.invoice) {
    const invoiceNumber = changes.after?.number || changes.before?.number;
    return `${HistoryActionTranslations[log.action]} ${TableNameTranslations[log.tableName]}: ${invoiceNumber}`;
  }

  return '';
}
